/** Bottom-right toast stack (OutlierOS components/ui/toaster.tsx). */
import { useEffect, useState } from 'react';
import { CheckCircle2, Info, X, XCircle } from 'lucide-react';
import { dismissToast, subscribeToasts, type ToastItem } from './toast';

export function Toaster() {
  const [items, setItems] = useState<ToastItem[]>([]);
  useEffect(() => subscribeToasts(setItems), []);
  return (
    <div aria-live="polite" className="fixed bottom-4 left-4 right-4 z-[200] flex flex-col gap-2 sm:left-auto sm:w-[380px]">
      {items.map((t) => {
        const Icon = t.kind === 'success' ? CheckCircle2 : t.kind === 'error' ? XCircle : Info;
        const color = t.kind === 'success' ? 'text-emerald-500' : t.kind === 'error' ? 'text-red-500' : 'text-primary';
        return (
          <div key={t.id} role={t.kind === 'error' ? 'alert' : 'status'} className="flex animate-toast-in items-start gap-3 rounded-2xl border border-border bg-card p-3.5 shadow-2xl">
            <Icon className={`mt-0.5 h-5 w-5 shrink-0 ${color}`} />
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold">{t.message}</p>
              {t.description && <p className="mt-0.5 break-words text-xs text-muted-foreground">{t.description}</p>}
              {t.action && (t.action.href
                ? <a href={t.action.href} className="mt-1.5 inline-block text-xs font-semibold text-primary">{t.action.label} →</a>
                : <button onClick={() => { t.action!.onClick?.(); dismissToast(t.id); }} className="mt-1.5 text-xs font-semibold text-primary">{t.action.label} →</button>)}
            </div>
            <button aria-label="Dismiss" onClick={() => dismissToast(t.id)} className="rounded-md p-0.5 text-muted-foreground hover:text-foreground"><X className="h-4 w-4" /></button>
          </div>
        );
      })}
    </div>
  );
}
